/**
 * Quiz pédagogiques déclenchés au premier franchissement d'un seuil fiscal.
 * Objectif : transformer un changement structurel imposé en moment d'apprentissage actif
 * (style examen apprenant Transport).
 */

export const FISCAL_QUIZZES = {
  micro_to_simplifie: {
    id: 'micro_to_simplifie',
    triggerWhen: 'CA glissant 12 mois > 188 700 € en statut Auto-entrepreneur',
    sender: 'Centre des Impôts',
    title: 'Examen pratique — Évolution de statut',
    intro: 'Vous avez franchi le seuil de 188 700 € de chiffre d\'affaires en Auto-entrepreneur. Un changement de régime fiscal est obligatoire. Avant de basculer automatiquement, l\'administration vous propose un test pédagogique :',
    question: 'Quel régime fiscal devez-vous adopter après le dépassement du plafond Auto-entrepreneur (188 700 € en transport) ?',
    options: [
      {
        id: 'reel_simplifie',
        label: 'Réel Simplifié',
        explanation: 'Bonne réponse ! Le Réel Simplifié est le régime obligatoire entre 188 700 € et 840 000 € de CA en transport. Il impose une comptabilité complète mais reste accessible avec une liasse fiscale simplifiée et une TVA trimestrielle.',
        correct: true,
      },
      {
        id: 'reel_normal',
        label: 'Réel Normal',
        explanation: 'Ce n\'est pas la bonne réponse. Le Réel Normal ne devient obligatoire qu\'au-delà de 840 000 € de CA en transport. Vous passez d\'abord par le Réel Simplifié, qui est moins contraignant (TVA trimestrielle, liasse simplifiée).',
        correct: false,
      },
      {
        id: 'micro_elargi',
        label: 'Micro-BIC élargi',
        explanation: 'Ce n\'est pas la bonne réponse — il n\'existe pas de Micro-BIC élargi en transport. Le régime Micro est strictement plafonné à 188 700 €. Au-delà, vous devez obligatoirement passer au Réel Simplifié.',
        correct: false,
      },
    ],
    correctReputationBonus: 5,
    wrongPenalty: 0,
    targetForm: 'ei',
    targetRegime: 'simplifie',
  },
  simplifie_to_normal: {
    id: 'simplifie_to_normal',
    triggerWhen: 'CA glissant 12 mois > 840 000 € en régime Réel Simplifié',
    sender: 'Centre des Impôts',
    title: 'Examen pratique — Évolution de régime',
    intro: 'Vous avez franchi le seuil de 840 000 € de chiffre d\'affaires en régime Réel Simplifié. Un passage en Réel Normal est obligatoire. Question pédagogique :',
    question: 'Quel est l\'impact principal du passage au Réel Normal ?',
    options: [
      {
        id: 'tva_mensuelle',
        label: 'TVA déclarée mensuellement + liasse fiscale complète',
        explanation: 'Bonne réponse ! Le Réel Normal impose une TVA mensuelle (au lieu de trimestrielle) et une liasse fiscale complète avec bilan détaillé, compte de résultat et annexes. Cela permet aussi l\'optimisation fiscale fine (amortissements accélérés, provisions, crédits d\'impôt).',
        correct: true,
      },
      {
        id: 'is_double',
        label: 'L\'IS est doublé',
        explanation: 'Ce n\'est pas exact. Le taux d\'IS reste identique : 15% jusqu\'à 42 500 € de bénéfice et 25% au-delà. Ce qui change, c\'est la précision de la comptabilité et la fréquence de la TVA (mensuelle au lieu de trimestrielle).',
        correct: false,
      },
      {
        id: 'sans_changement',
        label: 'Aucun changement majeur — c\'est administratif',
        explanation: 'Ce n\'est pas la bonne réponse. Le passage au Réel Normal implique une comptabilité plus lourde (liasse fiscale complète), une TVA mensuelle et des obligations renforcées de transparence. Ce n\'est pas anodin et nécessite souvent un comptable.',
        correct: false,
      },
    ],
    correctReputationBonus: 5,
    wrongPenalty: 0,
    targetForm: null, // legalForm unchanged, only regime changes
    targetRegime: 'normal',
  },
};

/**
 * Determine which fiscal quiz should fire (if any) for the given evolution.
 * Returns the quiz id or null if no quiz applies.
 */
export function pickFiscalQuiz(currentForm, currentRegime) {
  if (currentForm === 'auto') return 'micro_to_simplifie';
  if (currentRegime === 'simplifie') return 'simplifie_to_normal';
  return null;
}
